module.exports = __webpack_public_path__ + "static/media/Apple_Macbook.94a08682.jpg";